export const messageRowId = (channelId, sortOrder) => `channel-${channelId || 'unknown'}-message-${sortOrder || 'unknown'}`;

export const queryMessageRow = (channelId, sortOrder) => {
  if (typeof document === 'undefined') return null;
  return document.getElementById(messageRowId(channelId, sortOrder));
};
